import {CARGAR_NOTARIA} from '../types';

export const    cargarNotaria = val => {
    return {
        type: CARGAR_NOTARIA,
        payload: val
    }
}